import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */
/* @jsx mdx */
import DefaultLayout from "/Users/brandonwu/Documents/PTS/Gatsby/Instana-1-Day-Partner-Workshop/node_modules/gatsby-theme-carbon/src/templates/Default.js";
export const Title = () => <span>
    Lab 5 - Dynamic Focus Query <br />
  </span>;
;
export const _frontmatter = {};
const layoutProps = {
  Title,
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">



    <h2>{`Lab Overview`}</h2>
    <p>{`In this lab you will be introduced to the Dynamic Focus search functionality. The Instana Dynamic Focus search functionality can be used to filter the 3D maps, comparison tables, and incident views. The search bar has extensive abilities to search using fuzzy and wildcard searches as well as boolean operators.`}</p>
    <h2>{`Step 1:`}</h2>
    <p>{`Navigate to the Infrastructure screen in the UI.`}</p>
    <span {...{
      "className": "gatsby-resp-image-wrapper",
      "style": {
        "position": "relative",
        "display": "block",
        "marginLeft": "auto",
        "marginRight": "auto",
        "maxWidth": "1152px"
      }
    }}>{`
      `}<span parentName="span" {...{
        "className": "gatsby-resp-image-background-image",
        "style": {
          "paddingBottom": "65.27777777777779%",
          "position": "relative",
          "bottom": "0",
          "left": "0",
          "backgroundImage": "url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAANCAYAAACpUE5eAAAACXBIWXMAABYlAAAWJQFJUiTwAAACUUlEQVQ4y42RX2vTUBjGc6fIrgZ66+Z0063MwdZK2pomOec0bdPWrk2XNCdZ25x0gm5j3cTLgSCim4go+PVEr/0GgTyStBtOXPHi4Tn/3t/7vBxpPpOLlnIlsLoVmx2ORJWWgzxtQqYN5Glj6pN9IRGpQ61sQ69ZoPUuWs4AxOyAmBakuZWNaGGzCFJtx6yxg3LTBmt0wagJSmqg5MJrYKQGZQpVjBZKlTbUagf1ro/yMxulyjakOxtytCLrYE071qptGK0ejIaFF5QipBr6agEBVeGXa+DZHPJbBTzM6chkVaxlNaxlVTzaLGE1q0HWTUi3159EK4oBykVMdvqg9gDE7qNl9dCxHGyn6k3UccAsD1p3F3rXh37hO7vpmtl9SPOZbHRfMcD8UUy4SMCgnkCJhyh6eyh5I2ipwtSJF4JeI8MPISmbuUhRCAxPxMQNQN0AiVd5gNNXr9Ee7EHrDcH45O5v/VlT9gQkQ34aGRqDyYNY5wJlLlBwhnhzcIhf385xfnKSpksBFxP8Q8QVMLwQ0sJyJlrPqygnIydduIBsD3A2PsKPr2d4fzSGxv8HOE04t7oVLRTZJZBxgaIzwKfjI/z88gEfx2MwP0zP08IZwDTh3PLj6F6BpkDdDWDuhtDcIU73D/D98zu8HR9D8/eg9wLo7uyR04Q3lzLRYp5cSVjxBGq+wFA8R6sf4uX+CIcHI1R9cS00SZ58nHTrwfoVIJkWGF7yKEjdG4XwR+HkbEZK6g4h3Vhci+7KOowpkPLgcgQ2dcUJUhF39qckDX8DyZ37cAwsKkEAAAAASUVORK5CYII=')",
          "backgroundSize": "cover",
          "display": "block"
        }
      }}></span>{`
  `}<img parentName="span" {...{
        "className": "gatsby-resp-image-image",
        "alt": "Lab 5",
        "title": "Lab 5",
        "src": "/Instana-1-Day-Partner-Workshop/static/d90fcca97a540dc396eb81765878d30d/3cbba/lab5.1.png",
        "srcSet": ["/Instana-1-Day-Partner-Workshop/static/d90fcca97a540dc396eb81765878d30d/7fc1e/lab5.1.png 288w", "/Instana-1-Day-Partner-Workshop/static/d90fcca97a540dc396eb81765878d30d/a5df1/lab5.1.png 576w", "/Instana-1-Day-Partner-Workshop/static/d90fcca97a540dc396eb81765878d30d/3cbba/lab5.1.png 1152w", "/Instana-1-Day-Partner-Workshop/static/d90fcca97a540dc396eb81765878d30d/6d685/lab5.1.png 1596w"],
        "sizes": "(max-width: 1152px) 100vw, 1152px",
        "style": {
          "width": "100%",
          "height": "100%",
          "margin": "0",
          "verticalAlign": "middle",
          "position": "absolute",
          "top": "0",
          "left": "0"
        },
        "loading": "lazy",
        "decoding": "async"
      }}></img>{`
    `}</span>
    <h2>{`Step 2:`}</h2>
    <p>{`Use the following DFQs: `}</p>
    <pre><code parentName="pre" {...{}}>{`entity.host.name:<your_host_name> 
`}</code></pre>
    <pre><code parentName="pre" {...{}}>{`entity.host.name:<your_host_name> entity.type:host 
`}</code></pre>
    <pre><code parentName="pre" {...{}}>{`entity.host.name:<your_host_name> entity.selfType:host 
`}</code></pre>
    <pre><code parentName="pre" {...{}}>{`entity.zone:”PartnerTraining” 
`}</code></pre>
    <pre><code parentName="pre" {...{}}>{`entity.tag:Student=<your_last_name> 
`}</code></pre>
    <pre><code parentName="pre" {...{}}>{`entity.tag:"Application=Robot Shop"
`}</code></pre>
    <pre><code parentName="pre" {...{}}>{`entity.tag:Student=<your_last_name> entity.type:jvm 
`}</code></pre>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      